import React, { useEffect, useState } from 'react';
import LaptopIcon from 'mdi-react/LaptopIcon';
import CashMultipleIcon from 'mdi-react/CashMultipleIcon';
import OfficeBuildingIcon from 'mdi-react/OfficeBuildingIcon';
import SilverwareForkKnifeIcon from 'mdi-react/SilverwareForkKnifeIcon';
import BasketballIcon from 'mdi-react/BasketballIcon';
import HeartPulseIcon from 'mdi-react/HeartPulseIcon';
import TruckIcon from 'mdi-react/TruckIcon';
import ShapeIcon from 'mdi-react/ShapeIcon';
import Api from '../../../util/api';
import { partial } from '../../../util/translation/translation';
import DisplayCounter from '../../_uiComponents/DisplayCounter';
import {
  CATEGORY_GROUPS,
  getCategoryGroup,
} from '../../../util/companyCategoryGroups';

const p = partial('CompanyListPage');
const cg = partial('CategoryGroup');

const GROUP_DISPLAY = {
  BUSINESS_TECH_SERVICES: { color: 'default', icon: LaptopIcon },
  FINANCE_INSURANCE: { color: 'default', icon: CashMultipleIcon },
  CONSTRUCTION_INDUSTRY_PROPERTY: {
    color: 'default',
    icon: OfficeBuildingIcon,
  },
  RETAIL_FOOD_HOSPITALITY: {
    color: 'default',
    icon: SilverwareForkKnifeIcon,
  },
  MEDIA_SPORT_LEISURE: { color: 'default', icon: BasketballIcon },
  HEALTH_EDUCATION_PUBLIC: { color: 'default', icon: HeartPulseIcon },
  TRANSPORT_PRIMARY: { color: 'default', icon: TruckIcon },
  OTHER: { color: 'disabled', icon: ShapeIcon },
};

const CompanyCategoryBreakdown = () => {
  const [groupCounts, setGroupCounts] = useState({});

  useEffect(() => {
    Api.companies
      .getClubCompanies()
      .then((companies) => {
        const counts = {};
        (companies || []).forEach((company) => {
          const categories = company?.companyCategories?.length
            ? company.companyCategories
            : ['OTHER'];
          const groups = new Set(categories.map(getCategoryGroup));
          groups.forEach((group) => {
            counts[group] = (counts[group] || 0) + 1;
          });
        });
        setGroupCounts(counts);
      })
      .catch(() => undefined);
  }, []);

  const rows = Object.keys(CATEGORY_GROUPS)
    .map((group) => ({
      group,
      label: cg(group),
      count: groupCounts[group] || 0,
    }))
    .filter((row) => row.count > 0)
    .sort((a, b) => {
      if (a.group === 'OTHER') return 1;
      if (b.group === 'OTHER') return -1;
      return a.label.localeCompare(b.label);
    });

  if (rows.length === 0) {
    return null;
  }

  return (
    <div className="mb-3">
      <h4 className="mb-2">{p('categoryBreakdownTitle')}</h4>
      {rows.map((row) => {
        const { color, icon: Icon } = GROUP_DISPLAY[row.group];
        return (
          <DisplayCounter
            key={row.group}
            id={`category-${row.group}`}
            small
            color={color}
            title={row.label}
            value={`${row.count}`}
            icon={<Icon style={{ width: 14 }} />}
          />
        );
      })}
    </div>
  );
};

export default CompanyCategoryBreakdown;
